/*
 *  -----------------------------------------------------------------------
 *    <copyright file="login.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Settings from 'settings/settings';
import { Logger } from 'utils/logger';

const getDeviceId = () => {
    const parseHttpHeaders = (httpHeaders: string) =>
        httpHeaders
            .split('\n')
            .map((h) => h.split(/: */, 2))
            .filter((h) => h[0])
            .reduce((accumulator: Record<string, string>, currentHeader) => {
                const [name, value] = currentHeader;
                return { ...accumulator, [name]: value };
            }, {});

    // Get a "unique" device ID
    const req = new XMLHttpRequest();
    req.open('GET', document.location.toString(), false);
    req.send(null);
    const headers = parseHttpHeaders(req.getAllResponseHeaders());

    return `${navigator.userAgent}-${navigator.language}-${headers['content-encoding']}`;
};

const ApiLogin = async (email: string, password: string, orgCode?: string, phone?: string) => {
    let errorMessage = null;

    const response = await fetch(`${Settings.api.url()}/api/login`, {
        method: 'POST',
        body: JSON.stringify({
            username: email,
            password,
            organisationCode: orgCode,
            phone,
            device: getDeviceId(),
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    }).catch((error) => {
        Logger.error(`Exception logging in: ${error.message}`);
        errorMessage = error.message;
    });

    if (errorMessage || !response) return { error: errorMessage };

    try {
        return await response.json();
    } catch (error: any) {
        return { error: error.message };
    }
};

const ApiLogin2FA = async (token: string, code: string) => {
    let errorMessage = null;
    const response = await fetch(`${Settings.api.url()}/api/twofa`, {
        method: 'POST',
        body: JSON.stringify({
            token,
            code,
            device: getDeviceId(),
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    }).catch((error) => {
        Logger.error(`Exception in 2FA Authorization: ${error.message}`);
        errorMessage = error.message;
    });

    if (errorMessage || !response) return { error: errorMessage };

    try {
        return await response.json();
    } catch (error: any) {
        return { error: error.message };
    }
};

const Resend2FaCode = async (token: string) => {
    let errorMessage = null;
    Logger.log('Token:', token);
    const response = await fetch(`${Settings.api.url()}/api/resend2FaCode`, {
        method: 'POST',
        body: JSON.stringify({
            Token: token,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    }).catch((error) => {
        Logger.error(`Exception resending 2FA code via SMS: ${error.message}`);
        errorMessage = error.message;
    });

    if (errorMessage || !response) return { error: errorMessage };

    try {
        return await response.json();
    } catch (error: any) {
        return { error: error.message };
    }
};

export { ApiLogin, ApiLogin2FA, Resend2FaCode };
